import { render, staticRenderFns } from "./GeneralMap.vue?vue&type=template&id=2b0766a4&scoped=true"
import script from "./GeneralMap.vue?vue&type=script&lang=js"
export * from "./GeneralMap.vue?vue&type=script&lang=js"
import style0 from "./GeneralMap.vue?vue&type=style&index=0&id=2b0766a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0766a4",
  null
  
)

export default component.exports